import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ProgressOverlayComponent } from './progress-overlay/progress-overlay.component';

@NgModule({
    imports: [CommonModule, MatProgressSpinnerModule],
    declarations: [ProgressOverlayComponent],
    exports: [ProgressOverlayComponent]
})
export class SharedProgressOverlayModule {}
